import React from 'react';
import { Box, Typography } from '@mui/material';
import UsuarioForm from '../components/usuario/UsuarioForm';

const UsuarioEditar: React.FC = () => {
  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.125rem',
          lineHeight: 1.235
        }}
      >
        Editar Usuário
      </Typography>
      <UsuarioForm isEdit={true} />
    </Box>
  );
};

export default UsuarioEditar;
